import React from "react";
import { Avatar, Popover } from "antd";
import { IoIosArrowBack } from "react-icons/io";
import { NormalStyles, TitleCard } from "@/layouts/styles/ssr.style";
import Image from "next/image";
import { definitions } from "@/services/metruyenvl";
import { formatDistanceToNow } from "date-fns";
import { vi } from "date-fns/locale";

function NotificationItem({ item }: { item: definitions["models.UserNotification"] }) {
    const date = new Date((item.updated_time ?? 0) * 1000);
    const distance = formatDistanceToNow(date, {
        locale: vi,
        addSuffix: true,
    });
    return (
        <div className="flex gap-x-4 mb-0 pt-2 pl-4 pb-2 justify-between md:w-2/3 border-b border-solid border-stone-300">
            <div className="flex gap-x-4">
                {" "}
                <Image src={"https://fptshop.com.vn/Uploads/Originals/2023/11/22/638362929279006187_game-naruto_.jpg"} className="rounded-full h-14 w-14 object-cover" width={50} height={50} alt="avatar" />
                <div>
                    <TitleCard>{item.description}</TitleCard>
                    <NormalStyles>{distance}</NormalStyles>
                </div>
            </div>
            <div className="ml-4">
                {" "}
                <Popover
                    content={
                        <div>
                            <TitleCard>Đánh dấu đã đọc thông báo</TitleCard>
                            <TitleCard styles={{ marginTop: "10px" }}>Xoá thông báo</TitleCard>
                        </div>
                    }
                    placement="top"
                >
                    <IoIosArrowBack />
                </Popover>
            </div>
        </div>
    );
}

export default NotificationItem;
